import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-modale-supprimer',
  templateUrl: './modale-supprimer.component.html',
  standalone: false,
})
export class ModaleSupprimerComponent {
  @Input() show = false;
  @Input() variant: 'adresse' | 'telephone';
  @Output() suppressionConfirmee = new EventEmitter<void>();
  @Output() suppressionAnnulee = new EventEmitter<void>();

  public suppressionConfirmeeClick() {
    this.suppressionConfirmee.emit();
  }

  public suppressionAnnuleeClick() {
    this.suppressionAnnulee.emit();
  }
}
